import React, { SVGAttributes } from 'react'

const Asterisk: React.FC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'>
      <path
        d='M3.59067 8.15873L5.0829 6.28571L3 5.73016L3.43523 4.4127L5.4715 5.25397L5.30052 3H6.71503L6.54404 5.25397L8.56477 4.4127L9 5.73016L6.9171 6.28571L8.40933 8.15873L7.24352 9L6 6.92063L4.75648 9L3.59067 8.15873Z'
        fill='#EA5850'
      />
    </svg>
  )
}

export default Asterisk
